import { useTranslation } from 'react-i18next'

import { type IdAndName } from '@/types/id-and-name'

import styles from './UnableToPerfomAction.module.scss'
import Alert from '../Alert/Alert'
import Pagination from '../Pagination/Pagination'
import Table from '../Table/Table'

type UnableToPerfomActionProps = {
  alertTitle: React.ReactNode
  alertDescription: React.ReactNode
  unableToPerformActionData: IdAndName[]
  count: number
  page: number
  isTableLoading?: boolean
  pageSize: number
  onPageChange: (page: number) => void
}

const UnableToPerfomAction = (props: UnableToPerfomActionProps) => {
  const { t } = useTranslation('common')

  const isMoreThanFive = props.count > 5
  const isMoreThanPageSize = props.count > props.pageSize

  if (!props.count) return null

  return (
    <>
      <Alert
        message={props.alertTitle}
        variant="warning"
        description={props.alertDescription}
      />
      {isMoreThanFive ? (
        <div className={styles.topBarContainer}>
          <p className={styles.topBar}>
            {t('help.count-of-total', {
              start: props.page * props.pageSize - props.pageSize + 1,
              end: Math.min(props.page * props.pageSize, props.count),
              total: props.count
            })}
          </p>
        </div>
      ) : null}
      <div className={styles.table}>
        <Table
          id="bulk-action-modal-unable-table"
          showHeader={false}
          showTopBar={false}
          columns={[
            {
              key: 'name',
              dataIndex: 'name'
            }
          ]}
          data={props.unableToPerformActionData}
          isLoading={props.isTableLoading}
          caption={t('header.unable-to-perform-action')}
        />
      </div>
      {isMoreThanPageSize ? (
        <div className={styles.pagination}>
          <Pagination
            count={props.count}
            id="bulk-action-modal-unable-table-pagination"
            page={props.page}
            pageSize={props.pageSize}
            onPageChange={props.onPageChange}
          />
        </div>
      ) : null}
    </>
  )
}

export default UnableToPerfomAction
